const javascriptUtils = `
    function parseTime(startTime) {
        const startTs = startTime * 1000;
        const nowTs = Date.now();

        let delta = Math.abs(Math.floor((startTs - nowTs) / 1000))
        const days = Math.floor(delta / 86400);
        delta -= days * 86400;

        const hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;

        const minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;

        const seconds = Math.floor(delta) % 60;

        return [days, hours, minutes, seconds, startTs - nowTs < 0];
    }
`;

const javascriptCode = `
    ${javascriptUtils}

    function tick() {
        const startTime = \${values.data.startTime};
        const [d, h, m, s, finished] = parseTime(startTime);

        const template = finished ? (\\\`\${values.endTemplate}\\\`) : (\\\`\${values.template}\\\`);

        const result = template
            .replaceAll('{d}', '<span class="days">'+ d +'</span>')
            .replaceAll('{h}', '<span class="hours">'+ h +'</span>')
            .replaceAll('{m}', '<span class="minutes">'+ m +'</span>')
            .replaceAll('{s}', '<span class="seconds">'+ s +'</span>')
            .replaceAll('{H}', '<span class="hours padded">'+ String(h).padStart(2, '0') +'</span>')
            .replaceAll('{M}', '<span class="minutes padded">'+ String(m).padStart(2, '0') +'</span>')
            .replaceAll('{S}', '<span class="seconds padded">'+ String(s).padStart(2, '0') +'</span>')

        try {
            const element = document.querySelector("#\${values._meta.htmlID} .countdown");
            element.innerHTML = result;
        } catch (e) {
            clearInterval(window.$$\${values._meta.htmlID}_TID);
        }
    }

    if (window.$$\${values._meta.htmlID}_TID) clearInterval(window.$$\${values._meta.htmlID}_TID);
    window.$$\${values._meta.htmlID}_TID = setInterval(tick, 100);
`;

const cssCode = `
    .\${values._meta.htmlClassNames} {
        color: \${values.textColor};
        background: \${values.backgroundColor};

        border-radius: \${values.roundedCorners};

        border-bottom: \${values.border?.borderBottomWidth} \${values.border?.borderBottomStyle} \${values.border?.borderBottomColor};
        border-left: \${values.border?.borderLeftWidth} \${values.border?.borderLeftStyle} \${values.border?.borderLeftColor};
        border-right: \${values.border?.borderRightWidth} \${values.border?.borderRightStyle} \${values.border?.borderRightColor};
        border-top: \${values.border?.borderTopWidth} \${values.border?.borderTopStyle} \${values.border?.borderTopColor};
    }

    \${values.customCss}
`;

const htmlTemplate = `
    ${javascriptUtils}

    const [d, h, m, s, finished] = parseTime(values.data.startTime);

    const template = finished ? values?.endTemplate : values?.template;

    const result = template
        .replaceAll('{d}', '<span class="days">'+ d +'</span>')
        .replaceAll('{h}', '<span class="hours">'+ h +'</span>')
        .replaceAll('{m}', '<span class="minutes">'+ m +'</span>')
        .replaceAll('{s}', '<span class="seconds">'+ s +'</span>')
        .replaceAll('{H}', '<span class="hours padded">'+ String(h).padStart(2, '0') +'</span>')
        .replaceAll('{M}', '<span class="minutes padded">'+ String(m).padStart(2, '0') +'</span>')
        .replaceAll('{S}', '<span class="seconds padded">'+ String(s).padStart(2, '0') +'</span>')

    return "<div class='countdown'>" + result + "</div>";
`;

export default `
unlayer.registerTool({
    name: 'countdown',
    label: 'Countdown',
    icon: 'fa-clock',
    supportedDisplayModes: ['web'],
    options: {
        default: {
            position: 1,
            options: {
                textColor: {
                    label: 'Text color',
                    defaultValue: '#000000',
                    widget: 'color_picker'
                },
                template: {
                    label: 'Template',
                    defaultValue: '{d}d {h}h {m}m {s}s',
                    widget: 'rich_text'
                },
                endTemplate: {
                    label: 'Finished template',
                    defaultValue: 'Event has already begun!',
                    widget: 'rich_text'
                }
            }
        },
        background: {
            title: 'Background',
            position: 2,
            options: {
                backgroundColor: {
                    label: 'Background color',
                    defaultValue: 'transparent',
                    widget: 'color_picker'
                },
                roundedCorners: {
                    label: 'Rounded Border',
                    widget: 'padding',
                    defaultValue: '0px'
                },
                border: {
                    label: 'Border',
                    widget: 'border'
                }
            }
        },
        custom: {
            title: 'Custom code',
            position: 3,
            options: {
                customCss: {
                    label: 'Custom CSS',
                    defaultValue: '',
                    widget: 'html'
                }
            }
        }
    },
    values: {},
    renderer: {
        Viewer: unlayer.createViewer({
            render(values) {${htmlTemplate}}
        }),
        exporters: {
            web: function (values) {${htmlTemplate}}
        },
        head: {
            css: function (values) {
                return \`${cssCode}\`;
            },
            js: function (values) {
                return \`(function(){ ${javascriptCode} })();\`;
            }
        }
    }
});`;
